@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Rhode Island</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      @if (baseRules?.Reject_LevelOne_Checkbox === "show") {
        <div class="_mb-medium">
          <axis-checkbox
            [formControlName]="controls[1].formControlName"
            [heading]="controls[1].label"
          ></axis-checkbox>
        </div>
      }
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Rhode Island</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ controls[0].option[0].label }}
      </label>
    </div>
  }
  @if (baseRules?.Accept_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ controls[0].option[1].label }}
      </label>
      <div>{{ textValues?.LimitText }}</div>
    </div>
  }
}
